import React, { useEffect, useState } from "react";
import { Table, Tag, Button, Row } from "antd";
import { useLoading } from "../../context/loadingContext";
import dayjs from "dayjs";
import GetMerchantSettle from "../../functions/merchant/getMerchantSettle";
import moneyFormat from "../../functions/utils/moneyFormat";
import { EyeFilled, RedoOutlined } from "@ant-design/icons";
import SettleTransactions from "../../components/modal/settleTransactions";
import { useMerchant } from "../../context/merchantContext";
import SearchDatePickerIncome from "../../components/search/datePickerIncome";
import TablePagination from "components/pagination/tablePagination";
import { bg_button, bg_shadow, bg_text } from "constant/css";
import GetSubMerchantTransaction from "functions/merchant/getSubMerchantTransaction";
import SubMerchantSelect from "components/select/subMerchant";
import { getMerchantId } from "service/storage";

const SubMerchantIncome = () => {
  const { showLoading, hideLoading } = useLoading();
  const { searchFieldsIncome } = useMerchant();
  const [data, setData] = useState([]);
  const merchantId = getMerchantId();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [paginationData, setPaginationData] = useState({});
  const [showTransactions, setShowTransactions] = useState(null);
  const [subMerchantId, setSubMerchantId] = useState(null);
  const [totals, setTotals] = useState({
    totalAmount: 0,
    totalMerchant: 0,
    xpayTotal: 0,
    totalSubMerchant: 0,
  });
  useEffect(() => {
    prepareQueryStringAndSearch();
    // eslint-disable-next-line
  }, [searchFieldsIncome, page, pageSize]);

  const prepareQueryStringAndSearch = () => {
    const searchFieldsLength = Object.keys(searchFieldsIncome).length;
    let queryString = "";
    if (searchFieldsLength !== 0) {
      queryString = Object.keys(searchFieldsIncome)
        .map((key) => {
          if (!searchFieldsIncome[key]) return "";
          if (key.includes("At")) {
            return `${key}=${searchFieldsIncome[key]
              .map((e, i) => {
                if (i === 0)
                  return dayjs(e).startOf("day").format("YYYY-MM-DD HH:MM");
                return dayjs(e).endOf("day").format("YYYY-MM-DD HH:MM");
              })
              .join("->")}`;
          }
          return `${key}=${encodeURIComponent(searchFieldsIncome[key])}`;
        })
        .join("&");
      fetchInvoices(queryString, page, pageSize);
    }
  };

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      width: 20,
      className: "text-xs",
    },
    {
      title: "Нийт дүн",
      dataIndex: "amount",
      key: "amount",
      width: 20,
      render: (e) => <span className="text-xs">{moneyFormat(e)}₮</span>,
      className: "text-xs",
      align: "right",
    },
    {
      title: "Дэд мерчант дүн",
      dataIndex: "afterFeeAmount",
      key: "afterFeeAmount",
      width: 50,
      render: (e, r) => <span className="text-xs">{moneyFormat(e)}₮</span>,
      className: "text-xs",
      align: "right",
    },
    {
      title: "Мерчант дүн",
      dataIndex: "merchantFee",
      key: "merchantFee",
      width: 50,
      render: (e, r) => <span className="text-xs">{moneyFormat(e)}₮</span>,
      className: "text-xs",
      align: "right",
    },
    {
      title: "xPay авах дүн",
      dataIndex: "xpayFee",
      key: "xpayFee",
      width: 50,
      render: (e, r) => <span className="text-xs">{moneyFormat(e)}₮</span>,
      className: "text-xs",
      align: "right",
    },
    {
      title: (
        <SearchDatePickerIncome
          title="Үүссэн огноо"
          datePicker
          fieldName="createdAt"
        />
      ),
      dataIndex: "createdAt",
      key: "createdAt",
      width: 100,
      render: (e) => (
        <span className="text-xs">
          {e ? dayjs(e).format("YYYY-MM-DD") : "-"}
        </span>
      ),
      className: "text-xs",
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 50,
      render: (e) => <span className="text-xs">{e || "-"}</span>,
      className: "text-xs",
    },
  ];

  useEffect(() => {
    refresh();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (subMerchantId) fetchInvoices("", page, pageSize);
  }, [subMerchantId]);
  const fetchInvoices = async (queryString, page, size) => {
    showLoading();
    const response = await GetSubMerchantTransaction(
      merchantId,
      subMerchantId,
      `&page=${page}&size=${size}&${queryString}`
    );
    hideLoading();
    if (response) {
   
      setData(response.data);

      setPaginationData(response.pagination);
      setTotals({
        totalAmount: response.totalAmount || 0,
        totalMerchant: response.totalMerchant || 0,
        totalXpay: response.totalXpay || 0,
        totalSubMerchant: response.totalSubMerchantAmount || 0,
      });
    }
  };

  const changePage = (page) => {
    setPage(page);
    fetchInvoices("", page, pageSize);
  };

  const changeSize = (current, size) => {
    setPageSize(size);
    fetchInvoices("", current, size);
  };

  const refresh = () => {
    setPage(1);
    fetchInvoices("", 1, pageSize);
  };

  const closeShowTransactions = () => setShowTransactions(null);

  return (
    <div className="vatMerchantListontainer p-2 md:p-4">
      <Row className="mb-2 gap-2">
        <div className="w-full flex gap-4 max-w-[200px] flex-row">
          <SubMerchantSelect
            value={subMerchantId}
            onChange={(e) => setSubMerchantId(e)}
            merchantId={merchantId}
          />
          <Button
            type="primary"
            className={`${bg_button} rounded-xl ${bg_shadow}`}
            size="medium"
            onClick={refresh}
            icon={<RedoOutlined />}
          />
        </div>
      </Row>
      <div className="tableContainer">
        <Table
          columns={columns}
          rowKey={(record) => record.id}
          scroll={{
            x: "max-content",
            y: "calc(100vh - 48vh)",
          }}
          pagination={false}
          dataSource={data}
          size="small"
          className="text-xs"
          summary={() => {
            return (
              <Table.Summary fixed>
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0}></Table.Summary.Cell>
                  <Table.Summary.Cell index={1} align="right">
                    <span className={`font-semibold ${bg_text}`}>
                      {moneyFormat(totals.totalAmount)}
                    </span>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={4} align="right">
                    <span className="font-semibold">
                      {moneyFormat(totals.totalSubMerchant)}
                    </span>
                  </Table.Summary.Cell>

                  <Table.Summary.Cell index={6} align="right">
                    <span className="font-semibold ">
                      {moneyFormat(totals.totalMerchant)}
                    </span>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={7} align="right">
                    <span className="font-semibold ">
                      {moneyFormat(totals.totalXpay)}
                    </span>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={8} />
                  <Table.Summary.Cell index={9} />
                  <Table.Summary.Cell index={10} />
                  <Table.Summary.Cell
                    className="flex flex-row gap-1"
                    index={12}
                    align="center"
                  >
                    <Tag color="green" className="font-semibold ">
                      {totals.totalSuccess}
                    </Tag>
                    <Tag color="red" className="font-semibold ">
                      {totals.totalFailed}
                    </Tag>
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              </Table.Summary>
            );
          }}
        />
        <TablePagination
          page={page}
          paginationData={paginationData}
          changePage={changePage}
          changeSize={changeSize}
        />
      </div>
      {showTransactions && (
        <SettleTransactions
          open={showTransactions}
          refresh={refresh}
          close={closeShowTransactions}
        />
      )}
    </div>
  );
};

export default SubMerchantIncome;
